import { render } from "./CadastroClienteUsuarios.vue?vue&type=template&id=c7396120&scoped=true"
import script from "./CadastroClienteUsuarios.vue?vue&type=script&lang=ts"
export * from "./CadastroClienteUsuarios.vue?vue&type=script&lang=ts"

import "./CadastroClienteUsuarios.vue?vue&type=style&index=0&id=c7396120&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c7396120"

export default script